import { createFileRoute } from '@tanstack/react-router'
import { FEATURE } from '@trellis/shared'

import { FeatureGate } from '@/components/guards'
import { FeatureDisabledPage } from '@/pages/features/FeatureDisabledPage'
import { TagsSettingsPage } from '@/pages/settings/tags/TagsSettingsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/tags/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <FeatureGate feature={FEATURE.TAGS} fallback={<FeatureDisabledPage />}>
      <TagsSettingsPage />
    </FeatureGate>
  )
}
